// src/routes/NavigationListener.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export const NavigationListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: any) => navigate(e.detail);
    window.addEventListener("app-redirect", handler);
    return () => window.removeEventListener("app-redirect", handler);
  }, [navigate]);

  return null;
};